class OrderForm extends HTMLElement {
	connectedCallback() {
		this.lineItemsQuantityNodes = [...this.querySelectorAll('line-item-quantity')];
		this.maxWidthCapacity = this.querySelector('[max-width-capacity]');
		this.maxDepthCapacity = this.querySelector('[max-depth-capacity]');
		this.jarString = this.dataset.jar;
		this.jarsString = this.dataset.jars;
		this.addEventListener('line-item-quantity:change', this.onLineItemQuantityChange.bind(this));
		this.previousLineItems = [];
	}
	disconnectedCallback() {
		this.removeEventListener('line-item-quantity:change', this.onLineItemQuantityChange.bind(this));
	}
	get lineItems() {
		// All line items that could fit in the shelf
		return this.lineItemsQuantityNodes.filter((node) => !node.classList.contains('disabled')).map((node) => node.value);
	}
	get selectedLineItems() {
		// Only line items with quantity > 0
		return this.lineItemsQuantityNodes.map((node) => node.value).filter((value) => value.quantity > 0);
	}
	initWithLocalStorage(data) {
		this.lineItemsQuantityNodes.forEach((node) => node.initWithLocalStorage(0));
		data.lineItems.forEach((lineItem) => {
			const variantID = lineItem.variantID;
			const targetQtyNode = this.lineItemsQuantityNodes.find((node) => node.variantID == variantID);
			targetQtyNode.initWithLocalStorage(lineItem.quantity);
		});
	}
	onLineItemQuantityChange() {
		const newLineItems = this.selectedLineItems;
		if (JSON.stringify(newLineItems) !== JSON.stringify(this.previousLineItems)) {
			this.previousLineItems = newLineItems;
			this.dispatchEvent(
				new CustomEvent('order-form:change', {
					detail: { lineItems: newLineItems },
					bubbles: true,
				}),
			);
		}
	}
	setShelfCapacityInfo(bins, bufferSpace) {
		if (!this.maxWidthCapacity || !this.maxDepthCapacity) {
			return;
		}
		const maxWidth = Math.max(...bins.map((bin) => bin.width));
		const maxDepth = Math.max(...bins.map((bin) => bin.depth));
		const maxLineItemWidth = Math.max(...this.lineItems.map((item) => item.width));
		const maxLineItemDepth = Math.max(...this.lineItems.map((item) => item.depth));
		const howManyFitWidth = Math.floor((maxWidth - bufferSpace) / maxLineItemWidth);
		const howManyFitDepth = Math.floor((maxDepth - bufferSpace) / maxLineItemDepth);
		this.maxWidthCapacity.innerText = `${howManyFitWidth} ${howManyFitWidth === 1 ? this.jarString : this.jarsString}`;
		this.maxDepthCapacity.innerText = `${howManyFitDepth} ${howManyFitDepth === 1 ? this.jarString : this.jarsString}`;
	}
	setDimensions({ maxWidth, maxHeight, maxDepth, bufferSpace, bins }) {
		this.lineItemsQuantityNodes.forEach((LineItemQuantity) => {
			const { width, height, depth } = LineItemQuantity.value;
			if (width + bufferSpace >= maxWidth || height + bufferSpace >= maxHeight || depth + bufferSpace >= maxDepth) {
				LineItemQuantity.hide();
			} else {
				LineItemQuantity.show();
			}
		});
		const atLeastOneCouldFit = this.lineItemsQuantityNodes.some((LineItemQuantity) => LineItemQuantity.couldFit);
		this.classList.toggle('order-form__empty', !atLeastOneCouldFit);
		this.setShelfCapacityInfo(bins, bufferSpace);
		return atLeastOneCouldFit;
	}
	updateLineItemInputs(shelf) {
		this.lineItemsQuantityNodes.forEach((lineItemInput) => {
			const lineItem = lineItemInput.value;
			const doesOneMoreFit = shelf.doesLineItemFit(lineItem);
			lineItemInput.updateAddingLineItemButton(doesOneMoreFit);
		});
		this.onLineItemQuantityChange();
	}
	isShelfFull(shelf) {
		return this.lineItemsQuantityNodes.every((lineItemInput) => {
			const lineItem = lineItemInput.value;
			return !shelf.doesLineItemFit(lineItem);
		});
	}
	reset() {
		this.lineItemsQuantityNodes.forEach((node) => node.reset());
		this.previousLineItems = this.selectedLineItems;
	}
}
customElements.define('order-form', OrderForm);
